export const actionsEnum = {
  DATA_ERRORS: 'DATA_ERRORS',
  DATA_PROCESSING: 'DATA_PROCESSING',
  DATA_GET_SUCCESS: 'DATA_GET_SUCCESS',
  DATA_POST_SUCCESS: 'DATA_POST_SUCCESS',
  DATA_PUT_SUCCESS: 'DATA_PUT_SUCCESS',
  DATA_DELETE_SUCCESS: 'DATA_DELETE_SUCCESS',
  DATA_CLEAR: 'DATA_CLEAR',
  ERROR_CLEAR: 'ERROR_CLEAR',
  SORT: 'SORT',
  FILTER_SET: 'FILTER_SET',
  FILTER_SET_CATEGORY: 'FILTER_SET_CATEGORY',
  FILTER_CLEAR_CATEGORY: 'FILTER_CLEAR_CATEGORY',
  FILTER_CLEAR: 'FILTER_CLEAR',
};

export const actionTypes = {
  LOADING: 'LOADING',
  SAVING: 'SAVING',
  DELETING: 'DELETING',
};

export const entityTypes = {
  SINGLE: 'SINGLE',
  LIST: 'LIST',
};
